import { render, staticRenderFns } from "./BusEntityinfo.vue?vue&type=template&id=42b6f155&scoped=true&"
import script from "./BusEntityinfo.vue?vue&type=script&lang=js&"
export * from "./BusEntityinfo.vue?vue&type=script&lang=js&"
import style0 from "./BusEntityinfo.vue?vue&type=style&index=0&id=42b6f155&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b6f155",
  null
  
)

export default component.exports